var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "crash-home-game" }, [
    _c(
      "div",
      { staticClass: "game-container", attrs: { "data-tour": "game-win" } },
      [
        _c("div", { staticClass: "stats-panel" }, [
          _c(
            "div",
            {
              staticClass: "stat-card bank-card",
              attrs: { "data-tour": "game-bank" },
            },
            [
              _c("i", { staticClass: "icon icon_money-bold stat-icon" }),
              _c("div", { staticClass: "stat-content" }, [
                _c("div", { staticClass: "stat-value-row text-highlight" }, [
                  _c("i", {
                    staticClass: "icon icon_coin-bold stat-coin-icon",
                  }),
                  _c("span", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.allBetAmount)),
                  ]),
                ]),
                _c("span", { staticClass: "stat-label" }, [_vm._v("Bank")]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "stat-card players-card",
              attrs: { "data-tour": "game-players" },
            },
            [
              _c("i", { staticClass: "icon icon_users-bold stat-icon" }),
              _c("div", { staticClass: "stat-content" }, [
                _c("span", { staticClass: "stat-value text-white" }, [
                  _vm._v(_vm._s(_vm.playersCount)),
                ]),
                _c("span", { staticClass: "stat-label" }, [_vm._v("players")]),
              ]),
            ]
          ),
        ]),
        _vm.gameState == _vm.GAME_STATES.Over
          ? _c("RoundMvp", { attrs: { "mvp-list": _vm.mvpList } })
          : _vm._e(),
        _vm.gameState != _vm.GAME_STATES.Over
          ? _c("div", { staticClass: "timer-container is-multiplier" }, [
              _c("div", { staticClass: "multiplier-wrapper" }, [
                _vm.gameState == _vm.GAME_STATES.Starting
                  ? _c(
                      "div",
                      {
                        staticClass: "multiplier-block",
                        attrs: { "data-tour": "game-multiplier" },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "multiplier-value starting" },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.gameCountDownData.secondsLeft)),
                            ]),
                          ]
                        ),
                        _c(
                          "span",
                          { staticClass: "multiplier-label starting" },
                          [_vm._v("开始倒计时")]
                        ),
                      ]
                    )
                  : _vm.gameState == _vm.GAME_STATES.InProgress
                  ? _c(
                      "div",
                      {
                        staticClass: "multiplier-block",
                        attrs: { "data-tour": "game-multiplier" },
                      },
                      [
                        _c("span", { staticClass: "multiplier-value" }, [
                          _vm._v("x"),
                          _c("span", [_vm._v(_vm._s(_vm.tick))]),
                        ]),
                        _c("span", { staticClass: "multiplier-label" }, [
                          _vm._v("Multiplier"),
                        ]),
                      ]
                    )
                  : _vm.gameState == _vm.GAME_STATES.Crash
                  ? _c(
                      "div",
                      {
                        staticClass: "multiplier-block",
                        attrs: { "data-tour": "game-multiplier" },
                      },
                      [
                        _c("span", { staticClass: "multiplier-value" }, [
                          _vm._v("CRASH"),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm.gameState == _vm.GAME_STATES.InProgress &&
                _vm.spectateTarget.userId != 0 &&
                _vm.spectateTarget.player.status == 0
                  ? _c("div", { staticClass: "bets-info" }, [
                      _c("div", { staticClass: "bet-item text-white" }, [
                        _c("i", {
                          staticClass: "icon icon_coin-bold bet-icon",
                        }),
                        _c("span", { staticClass: "bet-value" }, [
                          _vm._v(_vm._s(_vm.spectateTarget.player.betAmount)),
                        ]),
                      ]),
                      _vm._m(0),
                      _c("div", { staticClass: "bet-item text-highlight" }, [
                        _c("i", {
                          staticClass: "icon icon_coin-bold bet-icon",
                        }),
                        _c("span", { staticClass: "bet-value" }, [
                          _vm._v(
                            _vm._s(
                              (
                                _vm.spectateTarget.player.betAmount * _vm.tick
                              ).toFixed(2)
                            )
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _c("div", { staticClass: "bet-creator-wrapper" }, [
          _vm.gameState == _vm.GAME_STATES.Starting ||
          _vm.gameState == _vm.GAME_STATES.InProgress
            ? _c(
                "div",
                {
                  staticClass: "bet-creator-dust",
                  attrs: { "data-tour": "game-start" },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-progress",
                      attrs: { disabled: "" },
                    },
                    [
                      _vm.gameState == _vm.GAME_STATES.Starting
                        ? _c("span", { staticClass: "btn__text" }, [
                            _vm._v("本局准备阶段..."),
                          ])
                        : _vm.gameState == _vm.GAME_STATES.InProgress
                        ? _c("span", { staticClass: "btn__text" }, [
                            _vm._v("对局进行中..."),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm.gameState == _vm.GAME_STATES.Starting
          ? _c("div", { staticClass: "gun-wrapper" }, [
              _c("img", {
                staticClass: "gun-image gun-sway",
                attrs: { src: require("../../assets/gun_1.png"), alt: "gun" },
              }),
            ])
          : _vm._e(),
        _vm.gameState == _vm.GAME_STATES.InProgress
          ? _c("div", { staticClass: "glitch-item-wrapper" }, [
              _c("div", { staticClass: "glitch-inner" }, [
                _c(
                  "div",
                  { staticClass: "glitch-image-box" },
                  [
                    _c("GlitchImage", {
                      attrs: {
                        src: _vm.currentLoot.src,
                        alt: _vm.currentLoot.name || "Loot Item",
                        "game-status": _vm.gameState,
                        "current-ratio": Number(_vm.tick) || 1,
                        coef: Number(_vm.crashPoint) || null,
                        "disable-animations":
                          this.spectateTarget.userId > 0 &&
                          this.spectateTarget.player.status != 0,
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "item-name-box" }, [
                  _c("div", { staticClass: "item-name-inner" }, [
                    _c("span", { staticClass: "item-name" }, [
                      _vm._v(_vm._s(_vm.currentLoot.name)),
                    ]),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "notifications-wrapper" },
          [
            _c("CrashNotifications", {
              attrs: {
                game: _vm.game,
                bets: _vm.crashOutPlayers,
                "current-ratio": Number(_vm.tick) || 1,
                "is-demo-mode": false,
                "streamer-mode": false,
              },
            }),
          ],
          1
        ),
        _vm.gameState == _vm.GAME_STATES.InProgress &&
        _vm.spectateTarget.userId > 0 &&
        _vm.spectateTarget.userId != _vm.user.id &&
        !_vm.$screen.mobile
          ? _c("div", { staticClass: "watching-box" }, [
              _c("div", { staticClass: "watching-info" }, [
                _c("span", { staticClass: "watching-label" }, [
                  _vm._v("Watching"),
                ]),
                _c("span", { staticClass: "watching-name" }, [
                  _vm._v(_vm._s(_vm.spectateTarget.player.name)),
                ]),
              ]),
              _vm._m(1),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bet-arrow" }, [
      _c("i", { staticClass: "icon icon_triangleRight" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "watching-icon-box" }, [
      _c("i", { staticClass: "icon icon_eye" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }